"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverdrawnModal = void 0;
const react_1 = __importDefault(require("react"));
const native_1 = require("styled-components/native");
const atoms_1 = require("../../atoms");
const SpacerDynamic_1 = __importDefault(require("../../../../stages/Atoms/SpacerDynamic/SpacerDynamic"));
const OverdrawnModal_styles_1 = require("./OverdrawnModal.styles");
const OverdrawnModal = ({ visible, balance, onActionButtonPress, message, heading, buttonMessage, }) => {
    const theme = native_1.useTheme();
    if (visible) {
        return (react_1.default.createElement(OverdrawnModal_styles_1.Wrapper, null,
            react_1.default.createElement(OverdrawnModal_styles_1.BackDrop, null),
            react_1.default.createElement(OverdrawnModal_styles_1.ModalContent, null,
                react_1.default.createElement(OverdrawnModal_styles_1.Container, null,
                    react_1.default.createElement(OverdrawnModal_styles_1.Title, { type: atoms_1.PTextType.VALUE, color: theme.bpCore.colors.dark[500] }, heading),
                    react_1.default.createElement(SpacerDynamic_1.default, { vSpace: 2 }),
                    react_1.default.createElement(OverdrawnModal_styles_1.BalanceText, null, balance),
                    react_1.default.createElement(SpacerDynamic_1.default, { vSpace: 2 }),
                    react_1.default.createElement(OverdrawnModal_styles_1.StyledText, { type: atoms_1.PTextType.VALUE, color: theme.bpCore.colors.dark[500] }, message),
                    react_1.default.createElement(SpacerDynamic_1.default, { vSpace: 4 }),
                    react_1.default.createElement(atoms_1.Button, { testID: "bottom-modal-action-button", type: atoms_1.ButtonAction.PRIMARY, onPress: onActionButtonPress, size: atoms_1.ButtonSize.DEFAULT }, buttonMessage)))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.OverdrawnModal = OverdrawnModal;
